// @generated by rtk-query-codegen -- DO NOT EDIT
import { baseApi as api } from "../client/baseApi";
import type { ArtifactResponse } from "../artifact/dto.generated";
import type { ETLTableStatus } from "../etlSource/domain.generated";
import type { CachedTableDTO, CertificateMetadataDTO, CleanupOrphanedSilverTableResponse, ConnectionMetadataDTO, ConnectivityResponse, ConnectorCapabilitiesDTO, DeleteSourceAcceptedResponse, DiscoverSchemaResponse, ETLSourceResponse, ListAllETLSourcesResponse, PipelineConfigDTO, ProbeConnectionResponse, ProjectSourcesHealthResponse, PublishSourceResponse, ReplaceFromUploadResponse, SSHTunnelMetadataDTO, SchemaChangesDTO, SharedArtifactResponse, SourceActivityDTO, SourceCapabilitiesResponse, SourceErrorDTO, SourceHealthDTO, SourceSummaryDTO, SourceTableResponse, SourceViewBlockDTO, SourceViewResponse, SupportedConnectorDTO, SupportedConnectorsResponse, TableViewBlockDTO, TangoExtraProcessDTO } from "../etlSource/dto.generated";
import type { WaitForPublishResponse } from "../etlTaskChain/dto.generated";
import type { ETLErrorCategory, ETLErrorConnector, ETLErrorInfo, ETLErrorReason, ETLErrorRemediation } from "../etlTasks/domain.generated";
export const addTagTypes = ["salesforce", "etl-sources", "tables"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getApiAuthSalesforceCallback: build.query<
        GetApiAuthSalesforceCallbackApiResponse,
        GetApiAuthSalesforceCallbackApiArg
      >({
        query: (queryArg) => ({
          url: `/api/auth/salesforce/callback`,
          params: {
            code: queryArg.code,
            state: queryArg.state,
          },
        }),
        providesTags: ["salesforce"],
      }),
      getApiProjectsByProjectIdEtlSources: build.query<
        GetApiProjectsByProjectIdEtlSourcesApiResponse,
        GetApiProjectsByProjectIdEtlSourcesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/etl-sources`,
        }),
        providesTags: ["etl-sources"],
      }),
      postApiProjectsByProjectIdEtlSources: build.mutation<
        PostApiProjectsByProjectIdEtlSourcesApiResponse,
        PostApiProjectsByProjectIdEtlSourcesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/etl-sources`,
          method: "POST",
          body: queryArg.etlSourceCreateEtlSourceRequest,
        }),
        invalidatesTags: ["etl-sources"],
      }),
      getApiProjectsByProjectIdEtlSourcesConnectors: build.query<
        GetApiProjectsByProjectIdEtlSourcesConnectorsApiResponse,
        GetApiProjectsByProjectIdEtlSourcesConnectorsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/etl-sources/connectors`,
        }),
        providesTags: ["etl-sources"],
      }),
      postApiProjectsByProjectIdEtlSourcesDiscover: build.mutation<
        PostApiProjectsByProjectIdEtlSourcesDiscoverApiResponse,
        PostApiProjectsByProjectIdEtlSourcesDiscoverApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/etl-sources/discover`,
          method: "POST",
          body: queryArg.etlSourceProbeConnectionRequest,
        }),
        invalidatesTags: ["etl-sources"],
      }),
      getApiProjectsByProjectIdEtlSourcesEvents: build.query<
        GetApiProjectsByProjectIdEtlSourcesEventsApiResponse,
        GetApiProjectsByProjectIdEtlSourcesEventsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/etl-sources/events`,
        }),
        providesTags: ["etl-sources"],
      }),
      getApiProjectsByProjectIdEtlSourcesHealth: build.query<
        GetApiProjectsByProjectIdEtlSourcesHealthApiResponse,
        GetApiProjectsByProjectIdEtlSourcesHealthApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/etl-sources/health`,
        }),
        providesTags: ["etl-sources"],
      }),
      postApiProjectsByProjectIdEtlSourcesNameCheck: build.mutation<
        PostApiProjectsByProjectIdEtlSourcesNameCheckApiResponse,
        PostApiProjectsByProjectIdEtlSourcesNameCheckApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/etl-sources/name-check`,
          method: "POST",
          body: queryArg.etlSourceCheckSourceNameRequest,
        }),
        invalidatesTags: ["etl-sources"],
      }),
      deleteApiProjectsByProjectIdEtlSourcesOrphanedSilverAndTableName:
        build.mutation<
          DeleteApiProjectsByProjectIdEtlSourcesOrphanedSilverAndTableNameApiResponse,
          DeleteApiProjectsByProjectIdEtlSourcesOrphanedSilverAndTableNameApiArg
        >({
          query: (queryArg) => ({
            url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/etl-sources/orphaned-silver/${encodeURIComponent(String(queryArg.tableName))}`,
            method: "DELETE",
          }),
          invalidatesTags: ["etl-sources"],
        }),
      getApiProjectsByProjectIdEtlSourcesOwn: build.query<
        GetApiProjectsByProjectIdEtlSourcesOwnApiResponse,
        GetApiProjectsByProjectIdEtlSourcesOwnApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/etl-sources/own`,
        }),
        providesTags: ["etl-sources"],
      }),
      postApiProjectsByProjectIdEtlSourcesProbe: build.mutation<
        PostApiProjectsByProjectIdEtlSourcesProbeApiResponse,
        PostApiProjectsByProjectIdEtlSourcesProbeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/etl-sources/probe`,
          method: "POST",
          body: queryArg.etlSourceProbeConnectionRequest,
        }),
        invalidatesTags: ["etl-sources"],
      }),
      postApiProjectsByProjectIdEtlSourcesReplaceFromUpload: build.mutation<
        PostApiProjectsByProjectIdEtlSourcesReplaceFromUploadApiResponse,
        PostApiProjectsByProjectIdEtlSourcesReplaceFromUploadApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/etl-sources/replace-from-upload`,
          method: "POST",
          body: queryArg.etlSourceReplaceFromUploadRequest,
        }),
        invalidatesTags: ["etl-sources"],
      }),
      getApiProjectsByProjectIdEtlSourcesAndSourceId: build.query<
        GetApiProjectsByProjectIdEtlSourcesAndSourceIdApiResponse,
        GetApiProjectsByProjectIdEtlSourcesAndSourceIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/etl-sources/${encodeURIComponent(String(queryArg.sourceId))}`,
        }),
        providesTags: ["etl-sources"],
      }),
      deleteApiProjectsByProjectIdEtlSourcesAndSourceId: build.mutation<
        DeleteApiProjectsByProjectIdEtlSourcesAndSourceIdApiResponse,
        DeleteApiProjectsByProjectIdEtlSourcesAndSourceIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/etl-sources/${encodeURIComponent(String(queryArg.sourceId))}`,
          method: "DELETE",
        }),
        invalidatesTags: ["etl-sources"],
      }),
      getApiProjectsByProjectIdEtlSourcesAndSourceIdArtifacts: build.query<
        GetApiProjectsByProjectIdEtlSourcesAndSourceIdArtifactsApiResponse,
        GetApiProjectsByProjectIdEtlSourcesAndSourceIdArtifactsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/etl-sources/${encodeURIComponent(String(queryArg.sourceId))}/artifacts`,
        }),
        providesTags: ["etl-sources"],
      }),
      getApiProjectsByProjectIdEtlSourcesAndSourceIdCapabilities: build.query<
        GetApiProjectsByProjectIdEtlSourcesAndSourceIdCapabilitiesApiResponse,
        GetApiProjectsByProjectIdEtlSourcesAndSourceIdCapabilitiesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/etl-sources/${encodeURIComponent(String(queryArg.sourceId))}/capabilities`,
        }),
        providesTags: ["etl-sources"],
      }),
      patchApiProjectsByProjectIdEtlSourcesAndSourceIdConnection:
        build.mutation<
          PatchApiProjectsByProjectIdEtlSourcesAndSourceIdConnectionApiResponse,
          PatchApiProjectsByProjectIdEtlSourcesAndSourceIdConnectionApiArg
        >({
          query: (queryArg) => ({
            url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/etl-sources/${encodeURIComponent(String(queryArg.sourceId))}/connection`,
            method: "PATCH",
            body: queryArg.etlSourceUpdateConnectionRequest,
          }),
          invalidatesTags: ["etl-sources"],
        }),
      patchApiProjectsByProjectIdEtlSourcesAndSourceIdConnectivity:
        build.mutation<
          PatchApiProjectsByProjectIdEtlSourcesAndSourceIdConnectivityApiResponse,
          PatchApiProjectsByProjectIdEtlSourcesAndSourceIdConnectivityApiArg
        >({
          query: (queryArg) => ({
            url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/etl-sources/${encodeURIComponent(String(queryArg.sourceId))}/connectivity`,
            method: "PATCH",
            body: queryArg.etlSourceUpdateConnectivityRequest,
          }),
          invalidatesTags: ["etl-sources"],
        }),
      postApiProjectsByProjectIdEtlSourcesAndSourceIdDiscoverSchema:
        build.mutation<
          PostApiProjectsByProjectIdEtlSourcesAndSourceIdDiscoverSchemaApiResponse,
          PostApiProjectsByProjectIdEtlSourcesAndSourceIdDiscoverSchemaApiArg
        >({
          query: (queryArg) => ({
            url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/etl-sources/${encodeURIComponent(String(queryArg.sourceId))}/discover-schema`,
            method: "POST",
          }),
          invalidatesTags: ["etl-sources"],
        }),
      patchApiProjectsByProjectIdEtlSourcesAndSourceIdIngestSettings:
        build.mutation<
          PatchApiProjectsByProjectIdEtlSourcesAndSourceIdIngestSettingsApiResponse,
          PatchApiProjectsByProjectIdEtlSourcesAndSourceIdIngestSettingsApiArg
        >({
          query: (queryArg) => ({
            url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/etl-sources/${encodeURIComponent(String(queryArg.sourceId))}/ingest-settings`,
            method: "PATCH",
            body: queryArg.etlSourceUpdateIngestSettingsRequest,
          }),
          invalidatesTags: ["etl-sources"],
        }),
      postApiProjectsByProjectIdEtlSourcesAndSourceIdPublish: build.mutation<
        PostApiProjectsByProjectIdEtlSourcesAndSourceIdPublishApiResponse,
        PostApiProjectsByProjectIdEtlSourcesAndSourceIdPublishApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/etl-sources/${encodeURIComponent(String(queryArg.sourceId))}/publish`,
          method: "POST",
        }),
        invalidatesTags: ["etl-sources"],
      }),
      getApiProjectsByProjectIdEtlSourcesAndSourceIdStatus: build.query<
        GetApiProjectsByProjectIdEtlSourcesAndSourceIdStatusApiResponse,
        GetApiProjectsByProjectIdEtlSourcesAndSourceIdStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/etl-sources/${encodeURIComponent(String(queryArg.sourceId))}/status`,
        }),
        providesTags: ["etl-sources"],
      }),
      patchApiProjectsByProjectIdEtlSourcesAndSourceIdTables: build.mutation<
        PatchApiProjectsByProjectIdEtlSourcesAndSourceIdTablesApiResponse,
        PatchApiProjectsByProjectIdEtlSourcesAndSourceIdTablesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/etl-sources/${encodeURIComponent(String(queryArg.sourceId))}/tables`,
          method: "PATCH",
          body: queryArg.etlSourceUpdateTablesRequest,
        }),
        invalidatesTags: ["etl-sources"],
      }),
      getApiProjectsByProjectIdEtlSourcesAndSourceIdView: build.query<
        GetApiProjectsByProjectIdEtlSourcesAndSourceIdViewApiResponse,
        GetApiProjectsByProjectIdEtlSourcesAndSourceIdViewApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/etl-sources/${encodeURIComponent(String(queryArg.sourceId))}/view`,
        }),
        providesTags: ["etl-sources"],
      }),
      postApiProjectsByProjectIdEtlSourcesAndSourceIdWaitPublish:
        build.mutation<
          PostApiProjectsByProjectIdEtlSourcesAndSourceIdWaitPublishApiResponse,
          PostApiProjectsByProjectIdEtlSourcesAndSourceIdWaitPublishApiArg
        >({
          query: (queryArg) => ({
            url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/etl-sources/${encodeURIComponent(String(queryArg.sourceId))}/wait-publish`,
            method: "POST",
            body: queryArg.etlTaskChainWaitForPublishRequest,
          }),
          invalidatesTags: ["etl-sources"],
        }),
      postApiProjectsByProjectIdSalesforceOauthStart: build.mutation<
        PostApiProjectsByProjectIdSalesforceOauthStartApiResponse,
        PostApiProjectsByProjectIdSalesforceOauthStartApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/salesforce/oauth/start`,
          method: "POST",
        }),
        invalidatesTags: ["salesforce"],
      }),
      getApiProjectsByProjectIdTables: build.query<
        GetApiProjectsByProjectIdTablesApiResponse,
        GetApiProjectsByProjectIdTablesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/tables`,
          params: {
            source_slug: queryArg.sourceSlug,
          },
        }),
        providesTags: ["tables"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as etlSourceApi };
export type GetApiAuthSalesforceCallbackApiResponse = unknown;
export type GetApiAuthSalesforceCallbackApiArg = {
  /** Authorization code from Salesforce */
  code: string;
  /** CSRF state */
  state: string;
};
export type GetApiProjectsByProjectIdEtlSourcesApiResponse =
  /** status 200 OK */ { data: EtlSourceListAllEtlSourcesResponse };
export type GetApiProjectsByProjectIdEtlSourcesApiArg = {
  /** Project ID */
  projectId: string;
};
export type PostApiProjectsByProjectIdEtlSourcesApiResponse =
  /** status 201 Created */ { data: EtlSourceEtlSourceResponse };
export type PostApiProjectsByProjectIdEtlSourcesApiArg = {
  /** Project ID */
  projectId: string;
  /** ETL source creation request */
  etlSourceCreateEtlSourceRequest: EtlSourceCreateEtlSourceRequest;
};
export type GetApiProjectsByProjectIdEtlSourcesConnectorsApiResponse =
  /** status 200 OK */ { data: EtlSourceSupportedConnectorsResponse };
export type GetApiProjectsByProjectIdEtlSourcesConnectorsApiArg = {
  /** Project ID */
  projectId: string;
};
export type PostApiProjectsByProjectIdEtlSourcesDiscoverApiResponse =
  /** status 200 OK */ { data: EtlSourceTableDescriptionDto[] };
export type PostApiProjectsByProjectIdEtlSourcesDiscoverApiArg = {
  /** Project ID */
  projectId: string;
  /** Source kind + the key of the stored connection secret */
  etlSourceProbeConnectionRequest: EtlSourceProbeConnectionRequest;
};
export type GetApiProjectsByProjectIdEtlSourcesEventsApiResponse = unknown;
export type GetApiProjectsByProjectIdEtlSourcesEventsApiArg = {
  /** Project ID */
  projectId: string;
};
export type GetApiProjectsByProjectIdEtlSourcesHealthApiResponse =
  /** status 200 OK */ { data: EtlSourceProjectSourcesHealthResponse };
export type GetApiProjectsByProjectIdEtlSourcesHealthApiArg = {
  /** Project ID */
  projectId: string;
};
export type PostApiProjectsByProjectIdEtlSourcesNameCheckApiResponse = unknown;
export type PostApiProjectsByProjectIdEtlSourcesNameCheckApiArg = {
  /** Project ID */
  projectId: string;
  /** The project's request and the name to check */
  etlSourceCheckSourceNameRequest: EtlSourceCheckSourceNameRequest;
};
export type DeleteApiProjectsByProjectIdEtlSourcesOrphanedSilverAndTableNameApiResponse =
  /** status 200 OK */ { data: EtlSourceCleanupOrphanedSilverTableResponse };
export type DeleteApiProjectsByProjectIdEtlSourcesOrphanedSilverAndTableNameApiArg =
  {
    /** Project ID */
    projectId: string;
    /** Silver table name */
    tableName: string;
  };
export type GetApiProjectsByProjectIdEtlSourcesOwnApiResponse =
  /** status 200 OK */ { data: EtlSourceEtlSourceResponse[] };
export type GetApiProjectsByProjectIdEtlSourcesOwnApiArg = {
  /** Project ID */
  projectId: string;
};
export type PostApiProjectsByProjectIdEtlSourcesProbeApiResponse =
  /** status 200 OK */ { data: EtlSourceProbeConnectionResponse };
export type PostApiProjectsByProjectIdEtlSourcesProbeApiArg = {
  /** Project ID */
  projectId: string;
  /** Source kind + the key of the stored connection secret */
  etlSourceProbeConnectionRequest: EtlSourceProbeConnectionRequest;
};
export type PostApiProjectsByProjectIdEtlSourcesReplaceFromUploadApiResponse =
  /** status 200 OK */ { data: EtlSourceReplaceFromUploadResponse };
export type PostApiProjectsByProjectIdEtlSourcesReplaceFromUploadApiArg = {
  /** Project ID */
  projectId: string;
  /** Upload path to match */
  etlSourceReplaceFromUploadRequest: EtlSourceReplaceFromUploadRequest;
};
export type GetApiProjectsByProjectIdEtlSourcesAndSourceIdApiResponse =
  /** status 200 OK */ { data: EtlSourceEtlSourceResponse };
export type GetApiProjectsByProjectIdEtlSourcesAndSourceIdApiArg = {
  /** Project ID */
  projectId: string;
  /** ETL Source ID */
  sourceId: string;
};
export type DeleteApiProjectsByProjectIdEtlSourcesAndSourceIdApiResponse =
  /** status 202 Accepted */ { data: EtlSourceDeleteSourceAcceptedResponse };
export type DeleteApiProjectsByProjectIdEtlSourcesAndSourceIdApiArg = {
  /** Project ID */
  projectId: string;
  /** ETL Source ID */
  sourceId: string;
};
export type GetApiProjectsByProjectIdEtlSourcesAndSourceIdArtifactsApiResponse =
  /** status 200 OK */ {
    [key: string]: ArtifactArtifactResponse;
  };
export type GetApiProjectsByProjectIdEtlSourcesAndSourceIdArtifactsApiArg = {
  /** Project ID */
  projectId: string;
  /** ETL Source ID */
  sourceId: string;
};
export type GetApiProjectsByProjectIdEtlSourcesAndSourceIdCapabilitiesApiResponse =
  /** status 200 OK */ { data: EtlSourceSourceCapabilitiesResponse };
export type GetApiProjectsByProjectIdEtlSourcesAndSourceIdCapabilitiesApiArg = {
  /** Project ID */
  projectId: string;
  /** Source ID */
  sourceId: string;
};
export type PatchApiProjectsByProjectIdEtlSourcesAndSourceIdConnectionApiResponse =
  /** status 200 OK */ { data: EtlSourceConnectionMetadataDto };
export type PatchApiProjectsByProjectIdEtlSourcesAndSourceIdConnectionApiArg = {
  /** Project ID */
  projectId: string;
  /** ETL Source ID */
  sourceId: string;
  /** Fields to set or remove */
  etlSourceUpdateConnectionRequest: EtlSourceUpdateConnectionRequest;
};
export type PatchApiProjectsByProjectIdEtlSourcesAndSourceIdConnectivityApiResponse =

    | /** status 200 OK */ ({ data: EtlSourceConnectivityResponse })
    | /** status 202 Accepted */ ({ data: EtlSourceConnectivityResponse });
export type PatchApiProjectsByProjectIdEtlSourcesAndSourceIdConnectivityApiArg =
  {
    /** Project ID */
    projectId: string;
    /** Source ID */
    sourceId: string;
    /** Connectivity cutover request */
    etlSourceUpdateConnectivityRequest: EtlSourceUpdateConnectivityRequest;
  };
export type PostApiProjectsByProjectIdEtlSourcesAndSourceIdDiscoverSchemaApiResponse =
  /** status 200 OK */ { data: EtlSourceDiscoverSchemaResponse };
export type PostApiProjectsByProjectIdEtlSourcesAndSourceIdDiscoverSchemaApiArg =
  {
    /** Project ID */
    projectId: string;
    /** ETL Source ID */
    sourceId: string;
  };
export type PatchApiProjectsByProjectIdEtlSourcesAndSourceIdIngestSettingsApiResponse =
  /** status 200 OK */ { data: EtlSourceConnectionMetadataDto };
export type PatchApiProjectsByProjectIdEtlSourcesAndSourceIdIngestSettingsApiArg =
  {
    /** Project ID */
    projectId: string;
    /** ETL Source ID */
    sourceId: string;
    /** Ingest settings to set or clear */
    etlSourceUpdateIngestSettingsRequest: EtlSourceUpdateIngestSettingsRequest;
  };
export type PostApiProjectsByProjectIdEtlSourcesAndSourceIdPublishApiResponse =
  /** status 200 OK */ EtlSourcePublishSourceResponse;
export type PostApiProjectsByProjectIdEtlSourcesAndSourceIdPublishApiArg = {
  /** Project ID */
  projectId: string;
  /** ETL Source ID */
  sourceId: string;
};
export type GetApiProjectsByProjectIdEtlSourcesAndSourceIdStatusApiResponse =
  /** status 200 OK */ { data: EtlSourceEtlSourceResponse };
export type GetApiProjectsByProjectIdEtlSourcesAndSourceIdStatusApiArg = {
  /** Project ID */
  projectId: string;
  /** ETL Source ID */
  sourceId: string;
};
export type PatchApiProjectsByProjectIdEtlSourcesAndSourceIdTablesApiResponse =
  /** status 200 OK */ { data: EtlSourceEtlSourceResponse };
export type PatchApiProjectsByProjectIdEtlSourcesAndSourceIdTablesApiArg = {
  /** Project ID */
  projectId: string;
  /** ETL Source ID */
  sourceId: string;
  /** Table descriptions */
  etlSourceUpdateTablesRequest: EtlSourceUpdateTablesRequest;
};
export type GetApiProjectsByProjectIdEtlSourcesAndSourceIdViewApiResponse =
  /** status 200 OK */ { data: EtlSourceSourceViewResponse };
export type GetApiProjectsByProjectIdEtlSourcesAndSourceIdViewApiArg = {
  /** Project ID */
  projectId: string;
  /** ETL Source ID */
  sourceId: string;
};
export type PostApiProjectsByProjectIdEtlSourcesAndSourceIdWaitPublishApiResponse =
  /** status 200 OK */ { data: EtlTaskChainWaitForPublishResponse };
export type PostApiProjectsByProjectIdEtlSourcesAndSourceIdWaitPublishApiArg = {
  /** Project ID */
  projectId: string;
  /** Source ID */
  sourceId: string;
  /** Long-poll timeout budget */
  etlTaskChainWaitForPublishRequest: EtlTaskChainWaitForPublishRequest;
};
export type PostApiProjectsByProjectIdSalesforceOauthStartApiResponse =
  /** status 200 OK */ {
    [key: string]: string;
  };
export type PostApiProjectsByProjectIdSalesforceOauthStartApiArg = {
  /** Project ID */
  projectId: string;
};
export type GetApiProjectsByProjectIdTablesApiResponse =
  /** status 200 OK */ { data: EtlSourceSourceTableResponse[] };
export type GetApiProjectsByProjectIdTablesApiArg = {
  /** Project ID */
  projectId: string;
  /** Source Slug */
  sourceSlug: string;
};
export type EtlSourceCertificateMetadataDto = CertificateMetadataDTO;
export type EtlSourceTangoExtraProcessDto = TangoExtraProcessDTO;
export type EtlSourceHeaderDeltaDto = {
  /** DocumentsPerCall sizes each detail read. 0 = auto-etl's default. */
  documents_per_call?: number;
  /** HeaderTable is the table the window is evaluated against, e.g. "BKPF". */
  header_table?: string;
  /** LinkColumns identify a document. Order carries no meaning: auto-etl picks which column to
    vary per read by how many distinct values the window holds and equality-matches the rest.
    Scope columns are required for correctness — a SAP document number repeats across company
    codes and fiscal years. */
  link_columns?: string[];
  /** MaxDocuments refuses the run when the window matches more documents than this. 0 = leave it
    to auto-etl's default. */
  max_documents?: number;
  /** WhereClause is the header predicate in SAP OpenSQL. Rolling-window tokens
    ("{{today-30d}}", "{{month_start}}", …) are rendered per run by auto-etl. */
  where_clause?: string;
};
export type EtlSourceConnectionMetadataDto = ConnectionMetadataDTO;
export type EtlSourcePipelineConfigDto = PipelineConfigDTO;
export type EtlSourceSshTunnelMetadataDto = SSHTunnelMetadataDTO;
export type EtlSourceColumnDescriptionDto = {
  description?: string;
  name: string;
  type?: string;
};
export type EtlSourceForeignKeyDescriptionDto = {
  constrained_columns?: string[];
  referred_columns?: string[];
  referred_table?: string;
};
export type EtlSourceSapHeaderDeltaConfigDto = {
  documents_per_call?: number;
  header_table?: string;
  header_where_clause?: string;
  link_columns?: string[];
  max_documents?: number;
  max_table_ratio?: number;
};
export type EtlSourceWindowReloadConfigDto = {
  column?: string;
  from?: string;
  min_ratio?: number;
  to?: string;
};
export type EtlSourceIncrementalConfigDto = {
  created_column?: string;
  deleted_column?: string;
  full_load_min_ratio?: number;
  /** See domain.SapHeaderDeltaConfig: set instead of UpdateColumn for a detail table whose window
    comes from a header table. Leading, for govet's fieldalignment. */
  header_delta?: EtlSourceSapHeaderDeltaConfigDto;
  lookback_minutes?: number;
  merge_key?: string;
  update_column?: string;
  /** See domain.WindowReloadConfig: set instead of MergeKey/UpdateColumn — the one profile with no
    merge key. */
  window?: EtlSourceWindowReloadConfigDto;
};
export type EtlSourceCachedTableDto = CachedTableDTO;
export type EtlSourceTableDescriptionDto = {
  columns: EtlSourceColumnDescriptionDto[];
  description?: string;
  foreign_keys?: EtlSourceForeignKeyDescriptionDto[];
  incremental?: EtlSourceIncrementalConfigDto;
  layer_id?: string;
  name: string;
  not_null_columns?: string[];
  primary_keys?: string[];
  unique_columns?: string[];
};
export type EtlSourceEtlSourceResponse = ETLSourceResponse;
export type DomainAuditColumn = {
  change?: string;
  column?: string;
  reason?: string;
};
export type DomainAuditReport = {
  columns?: DomainAuditColumn[];
};
export type DomainColumnDescription = {
  description?: string;
  name?: string;
  table_id?: string;
  type?: string;
};
export type DomainForeignKeyDescription = {
  constrained_columns?: string[];
  referred_columns?: string[];
  referred_table?: string;
};
export type DomainSapHeaderDeltaConfig = {
  documents_per_call?: number;
  header_table?: string;
  header_where_clause?: string;
  link_columns?: string[];
  max_documents?: number;
  /** MaxTableRatio refuses a run whose projected read reaches this share of the rows bronze holds.
    A pointer because 0 disables the check and absent means auto-etl's 1.0. */
  max_table_ratio?: number;
};
export type DomainWindowReloadConfig = {
  column?: string;
  from?: string;
  /** MinRatio refuses a window that comes back under this fraction of the rows it replaces. A
    pointer because 0 is meaningful (it disables the guard) and absent means auto-etl's 0.5. */
  min_ratio?: number;
  to?: string;
};
export type DomainIncrementalConfig = {
  created_column?: string;
  deleted_column?: string;
  /** FullLoadMinRatio rolls back a full load that lands under this share of the rows it replaces.
    Carried whatever else is set, since any table can resolve to a full load; a pointer because 0
    disables the guard and absent means auto-etl's 0.5. */
  full_load_min_ratio?: number;
  /** Set instead of UpdateColumn when the delta comes from a header table. Nested here rather than
    sitting beside Incremental because MergeKey is genuinely shared by every merge profile — this
    says only *how the delta is found*, not whether the table merges. */
  header_delta?: DomainSapHeaderDeltaConfig;
  lookback_minutes?: number;
  merge_key?: string;
  update_column?: string;
  /** Set instead of MergeKey/UpdateColumn: a window reload merges nothing, so it names no key. It
    lives on this struct despite the name because this is the one home for "how this table is
    loaded" — the struct predates the profile taxonomy, and a sibling field on TableDescription
    would give a table two places to answer the same question. */
  window?: DomainWindowReloadConfig;
};
export type DomainTableDescription = {
  audit_report?: DomainAuditReport;
  code?: string;
  columns?: DomainColumnDescription[];
  description?: string;
  foreign_keys?: DomainForeignKeyDescription[];
  incremental?: DomainIncrementalConfig;
  is_shared?: boolean;
  layer_id?: string;
  name?: string;
  not_null_columns?: string[];
  primary_keys?: string[];
  provider_database?: string;
  provider_project_name?: string;
  unique_columns?: string[];
};
export type EtlSourceSharedArtifactResponse = SharedArtifactResponse;
export type EtlSourceListAllEtlSourcesResponse = ListAllETLSourcesResponse;
export type EtlSourceCreateEtlSourceRequest = {
  config_key: string;
  engine: string;
  /** FileKeys are the full S3 object keys of the uploaded files this source is
    built from (s3 kind only). When present they are persisted as
    fs_node_sources rows so the file tree can show a per-file source chip.
    Optional — omitted for non-upload sources. */
  file_keys?: string[];
  kind: string;
  name: string;
  /** PrivateConnectionID attaches the new source to a private connection of the
    project's workspace, so a source can be created already on private
    connectivity instead of being created direct and cut over afterwards.
    
    Optional and omitted for every other source. It is the only connectivity
    field on this request: switching an existing source between transports goes
    through PATCH .../connectivity, which exists so that a credential save can
    never be the thing that changes a network path. */
  private_connection_id?: string;
  request_id: string;
  slug: string;
  tables_descriptions?: EtlSourceTableDescriptionDto[];
};
export type EtlSourceConnectorCapabilitiesDto = ConnectorCapabilitiesDTO;
export type EtlSourceSupportedConnectorDto = SupportedConnectorDTO;
export type EtlSourceSupportedConnectorsResponse = SupportedConnectorsResponse;
export type EtlSourceProbeConnectionRequest = {
  config_key: string;
  engine?: string;
  kind: string;
};
export type EtlSourceSourceHealthDto = SourceHealthDTO;
export type EtlSourceProjectSourcesHealthResponse = ProjectSourcesHealthResponse;
export type EtlSourceCheckSourceNameRequest = {
  name: string;
  request_id: string;
  slug?: string;
};
export type EtlSourceCleanupOrphanedSilverTableResponse = CleanupOrphanedSilverTableResponse;
export type EtlSourceProbeConnectionResponse = ProbeConnectionResponse;
export type EtlSourceReplaceFromUploadResponse = ReplaceFromUploadResponse;
export type EtlSourceReplaceFromUploadRequest = {
  path: string;
};
export type EtlSourceDeleteSourceAcceptedResponse = DeleteSourceAcceptedResponse;
export type ArtifactArtifactResponse = ArtifactResponse;
export type EtlSourceSourceCapabilitiesResponse = SourceCapabilitiesResponse;
export type EtlSourceUpdateConnectionRequest = {
  remove?: string[];
  set?: object;
};
export type EtlSourceConnectivityMode = "direct" | "ssh" | "private_connection";
export type EtlSourceSshTunnelConfig = {
  host?: string;
  port?: number;
  username?: string;
};
export type EtlSourceConnectivityResponse = ConnectivityResponse;
export type EtlSourceUpdateConnectivityRequest = {
  /** Mode is required. It is not defaulted: acquiring or losing a network path is
    not something a caller should be able to do by omission. */
  mode: EtlSourceConnectivityMode;
  /** PrivateConnectionID is required when Mode is private_connection and ignored
    otherwise. */
  private_connection_id?: string;
  /** SSH is required when Mode is ssh and ignored otherwise. The private key is
    never part of this: it lives on the workspace and does not leave the backend. */
  ssh?: EtlSourceSshTunnelConfig;
};
export type EtlSourceSchemaChangesDto = SchemaChangesDTO;
export type EtlSourceDiscoverSchemaResponse = DiscoverSchemaResponse;
export type EtlSourceUpdateIngestSettingsRequest = {
  /** FunctionModule is the reader function module (e.g. "ZRFC_READ_TABLE"). A blank string clears
    it, which restores the connector's stock default. */
  function_module?: string;
  /** HeaderDeltaByTable is the legacy header-driven delta configuration, superseded by the
    per-table `incremental.header_delta` spec that `UpdateTables` writes. Accepted so a source
    still on the old shape can be corrected without a credential, not so new ones adopt it. */
  header_delta_by_table?: {
    [key: string]: EtlSourceHeaderDeltaDto;
  };
  /** RowBufferBytes is that module's work-area width. Zero clears it, restoring the default; it is
    never sent as zero otherwise, because auto-etl validates it as greater than zero. */
  row_buffer_bytes?: number;
  /** WatermarkFormatByTable says how to turn a stored watermark back into a literal, keyed by
    table; WatermarkFormats above is the accepted set. Same nil/empty semantics as WhereByTable. */
  watermark_format_by_table?: {
    [key: string]: string;
  };
  /** WhereByTable is the per-table row filter, keyed by SAP table name, in the source's own
    predicate syntax. Nil leaves the stored map untouched; an empty map removes every filter. */
  where_by_table?: {
    [key: string]: string;
  };
};
export type EtlSourcePublishSourceResponse = PublishSourceResponse;
export type EtlSourceUpdateTablesRequest = {
  /** ClearIncremental names the tables whose stored incremental config this write removes. A
    table in tables_descriptions without `incremental` keeps the config it has. */
  clear_incremental?: string[];
  /** IngestSettings, when present, is stored with the tables and goes out in the same publish. */
  ingest_settings?: EtlSourceUpdateIngestSettingsRequest;
  tables_descriptions: EtlSourceTableDescriptionDto[];
};
export type DomainEtlErrorCategory = ETLErrorCategory;
export type DomainEtlErrorConnector = ETLErrorConnector;
export type DomainEtlErrorReason = ETLErrorReason;
export type DomainEtlErrorRemediation = ETLErrorRemediation;
export type DomainEtlErrorInfo = ETLErrorInfo;
export type EtlSourceSourceErrorDto = SourceErrorDTO;
export type DomainEtlTableStatus = ETLTableStatus;
export type EtlSourceTableViewBlockDto = TableViewBlockDTO;
export type EtlSourceSourceActivityDto = SourceActivityDTO;
export type EtlSourceSourceSummaryDto = SourceSummaryDTO;
export type EtlSourceSourceViewBlockDto = SourceViewBlockDTO;
export type EtlSourceSourceViewResponse = SourceViewResponse;
export type EtlTaskChainWaitForPublishResponse = WaitForPublishResponse;
export type EtlTaskChainWaitForPublishRequest = {
  /** TimeoutSeconds bounds how long the backend will hold the connection
    open while waiting for the setup chain to reach a terminal state.
    Clamped to [5, 120] server-side. Defaults to 30 when omitted or 0. */
  timeout_seconds?: number;
};
export type EtlSourceSourceTableResponse = SourceTableResponse;
export const {
  useGetApiAuthSalesforceCallbackQuery,
  useLazyGetApiAuthSalesforceCallbackQuery,
  useGetApiProjectsByProjectIdEtlSourcesQuery,
  useLazyGetApiProjectsByProjectIdEtlSourcesQuery,
  usePostApiProjectsByProjectIdEtlSourcesMutation,
  useGetApiProjectsByProjectIdEtlSourcesConnectorsQuery,
  useLazyGetApiProjectsByProjectIdEtlSourcesConnectorsQuery,
  usePostApiProjectsByProjectIdEtlSourcesDiscoverMutation,
  useGetApiProjectsByProjectIdEtlSourcesEventsQuery,
  useLazyGetApiProjectsByProjectIdEtlSourcesEventsQuery,
  useGetApiProjectsByProjectIdEtlSourcesHealthQuery,
  useLazyGetApiProjectsByProjectIdEtlSourcesHealthQuery,
  usePostApiProjectsByProjectIdEtlSourcesNameCheckMutation,
  useDeleteApiProjectsByProjectIdEtlSourcesOrphanedSilverAndTableNameMutation,
  useGetApiProjectsByProjectIdEtlSourcesOwnQuery,
  useLazyGetApiProjectsByProjectIdEtlSourcesOwnQuery,
  usePostApiProjectsByProjectIdEtlSourcesProbeMutation,
  usePostApiProjectsByProjectIdEtlSourcesReplaceFromUploadMutation,
  useGetApiProjectsByProjectIdEtlSourcesAndSourceIdQuery,
  useLazyGetApiProjectsByProjectIdEtlSourcesAndSourceIdQuery,
  useDeleteApiProjectsByProjectIdEtlSourcesAndSourceIdMutation,
  useGetApiProjectsByProjectIdEtlSourcesAndSourceIdArtifactsQuery,
  useLazyGetApiProjectsByProjectIdEtlSourcesAndSourceIdArtifactsQuery,
  useGetApiProjectsByProjectIdEtlSourcesAndSourceIdCapabilitiesQuery,
  useLazyGetApiProjectsByProjectIdEtlSourcesAndSourceIdCapabilitiesQuery,
  usePatchApiProjectsByProjectIdEtlSourcesAndSourceIdConnectionMutation,
  usePatchApiProjectsByProjectIdEtlSourcesAndSourceIdConnectivityMutation,
  usePostApiProjectsByProjectIdEtlSourcesAndSourceIdDiscoverSchemaMutation,
  usePatchApiProjectsByProjectIdEtlSourcesAndSourceIdIngestSettingsMutation,
  usePostApiProjectsByProjectIdEtlSourcesAndSourceIdPublishMutation,
  useGetApiProjectsByProjectIdEtlSourcesAndSourceIdStatusQuery,
  useLazyGetApiProjectsByProjectIdEtlSourcesAndSourceIdStatusQuery,
  usePatchApiProjectsByProjectIdEtlSourcesAndSourceIdTablesMutation,
  useGetApiProjectsByProjectIdEtlSourcesAndSourceIdViewQuery,
  useLazyGetApiProjectsByProjectIdEtlSourcesAndSourceIdViewQuery,
  usePostApiProjectsByProjectIdEtlSourcesAndSourceIdWaitPublishMutation,
  usePostApiProjectsByProjectIdSalesforceOauthStartMutation,
  useGetApiProjectsByProjectIdTablesQuery,
  useLazyGetApiProjectsByProjectIdTablesQuery,
} = injectedRtkApi;
